<div class="auth-container">
  <!-- Decorative animated background -->
  <div class="bg-decor" aria-hidden="true">
    <div class="orb orb-1"></div>
    <div class="orb orb-2"></div>
    <div class="orb orb-3"></div>
    <div class="grid-overlay"></div>
  </div>

  <div class="lang-switcher-top">
    <button mat-button class="lang-chip" (click)="lang.toggle()" [matTooltip]="'HEADER.LANGUAGE' | translate">
      <mat-icon>language</mat-icon>
      {{ lang.current === 'ar' ? 'EN' : 'ع' }}
    </button>
  </div>

  <mat-card class="auth-card">
    <div class="card-content">
      <!-- Brand panel — video identity -->
      <div class="brand-panel">
        <div class="brand-badge">
          <span class="badge-dot"></span>
          <span>{{ 'LOGIN.BRAND_BADGE' | translate }}</span>
        </div>

        <div class="video-wrap">
          <video
            #brandVideo
            class="brand-video"
            src="assets/videos/brand-intro.mp4"
            autoplay
            playsinline
            preload="auto"
            [muted]="true"
            (ended)="onBrandVideoEnded(brandVideo)"
            tabindex="-1"
            aria-hidden="true"></video>
        </div>

        <div class="brand-footer">
          <mat-icon>verified_user</mat-icon>
          <span>{{ 'LOGIN.SECURE_NOTE' | translate }}</span>
        </div>
      </div>

      <!-- Form panel -->
      <div class="form-section">
        <div class="form-content">
          @if (sessionCheckPending) {
          <div class="session-check">
            <mat-spinner diameter="40"></mat-spinner>
          </div>
          } @else {
          <div class="form-head anim anim-1">
            <h2 class="title">{{ 'LOGIN.TITLE' | translate }}</h2>
            <p class="subtitle">{{ 'LOGIN.SUBTITLE' | translate }}</p>
          </div>

          <form [formGroup]="authForm" (ngSubmit)="onSubmit()" class="auth-form">
            <!-- Username Field -->
            <mat-form-field appearance="outline" class="form-field anim anim-2">
              <mat-label>{{ 'LOGIN.USERNAME' | translate }}</mat-label>
              <mat-icon matPrefix class="field-icon">person_outline</mat-icon>
              <input matInput formControlName="username" [placeholder]="'LOGIN.USERNAME_PLACEHOLDER' | translate" />
              @if (authForm.get('username')?.hasError('required')) {
              <mat-error>
                {{ 'LOGIN.USERNAME_REQUIRED' | translate }}
              </mat-error>
              }
            </mat-form-field>

            <!-- Password Field -->
            <mat-form-field appearance="outline" class="form-field anim anim-3">
              <mat-label>{{ 'LOGIN.PASSWORD' | translate }}</mat-label>
              <mat-icon matPrefix class="field-icon">lock_outline</mat-icon>
              <input matInput [type]="hide ? 'password' : 'text'" formControlName="password"
                (keydown)="onPasswordKeyEvent($event)" (keyup)="onPasswordKeyEvent($event)"
                [placeholder]="'LOGIN.PASSWORD_PLACEHOLDER' | translate" />
              <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'COMMON.HIDE_PASSWORD' | translate"
                [attr.aria-pressed]="hide" type="button">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              @if (authForm.get('password')?.hasError('required')) {
              <mat-error>
                {{ 'LOGIN.PASSWORD_REQUIRED' | translate }}
              </mat-error>
              }
            </mat-form-field>

            <!-- Caps Lock hint -->
            @if (capsLockOn) {
            <div class="caps-hint">
              <mat-icon>keyboard_capslock</mat-icon>
              <span>{{ 'LOGIN.CAPS_ON' | translate }}</span>
            </div>
            }

            <!-- Remember Me + Forgot password -->
            <div class="remember-forgot anim anim-4">
              <mat-checkbox [(ngModel)]="rememberMe" [ngModelOptions]="{standalone: true}" name="rememberMe" (change)="onRememberMeChange()">
                {{ 'LOGIN.REMEMBER_ME' | translate }}
              </mat-checkbox>
              <a class="forgot-password-link" role="button" tabindex="0"
                (click)="forgotPassword()" (keydown.enter)="forgotPassword()">
                {{ 'LOGIN.FORGOT_PASSWORD' | translate }}
              </a>
            </div>

            <!-- Login Button -->
            <button mat-raised-button type="submit" class="create-btn anim anim-5" [disabled]="authForm.invalid || loading">
              @if (loading) {
              <mat-spinner diameter="20" class="btn-spinner"></mat-spinner>
              }
              @if (!loading) {
              <span class="btn-label">
                {{ 'LOGIN.LOGIN_BTN' | translate }}
                <mat-icon class="btn-arrow">arrow_forward</mat-icon>
              </span>
              }
            </button>

            <!-- Error Message -->
            @if (error) {
            <div class="error-message">
              <mat-icon>error_outline</mat-icon>
              <span>{{ error }}</span>
            </div>
            }
          </form>
          }
        </div>
      </div>
    </div>
  </mat-card>

  <!-- Maker credit -->
  <div class="powered-by">
    <span>{{ 'LOGIN.POWERED_BY' | translate }}</span>
    <a href="https://apps-root.com/" target="_blank" rel="noopener noreferrer" class="powered-brand">AppsRoot</a>
  </div>
</div>
